module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select-org', {
    attrs: {
      "label": _vm.label,
      "type": "Contractor",
      "required": _vm.required,
      "placeholder": _vm.placeholder,
      "help-text": _vm.helpText,
      "no-form": _vm.noForm,
      "value-key": "value",
      "size": _vm.size,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66cf24df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectContractor.vue
// module id = 1611
// module chunks = 0